import React from 'react';
import RestClient from '../../rest/RestClient';
import {Globs, FLAG, KEY} from '../../Globs';
import Entrance from './../Entrance';
import moment from 'moment';
import MicroEvent  from '../../other/microevent';
import CommonHelper from '../../helpers/CommonHelper';
import { confirmAlert } from 'react-confirm-alert'; // Import

import Obtainer from '../../helpers/Obtainer';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';

export default class PanelActivity extends React.Component {

  id_waitForObtain = null;

  constructor(props) {
    super(props);

    MicroEvent.mixin(PanelActivity);
    //this.bind('setOptionsDisabled');

    this.state = {
      activityOn: false,
      redraw: 0,
      followed: '?',
      unfollowed: '?',
      time_spent: '?',
    };

    //this is added to avoid TypeError: Cannot read property 'setState' of null
    //on //this.setState({activityOn: !this.state.activityOn});

    this.handleStartStopActivityClicked = this.handleStartStopActivityClicked.bind(this);
    this.handleCancelActivityClicked = this.handleCancelActivityClicked.bind(this);

    Obtainer.mixin(PanelActivity);

    this.bindPeriodicalObtain(
      this.OBTAINS().PROCESS,
      ()=>{
        this.setState({activityOn: false});
        this.markUI_busy();
      },
      (process) => {
        if (process == null) {
            //console.log("no processes");
            Globs.setActivityFlag(FLAG.IDLE);
            this.markUI_nonBusy();
            this.trigger('setOptionsDisabled', false);
        }
        else {
          switch (process['status']) {
          case 'failed':
          case 'succeeded':
            Globs.setActivityFlag(FLAG.IDLE);
            //Globs.set(KEY.OPTIONS_DISABLED, false);
            this.trigger('setOptionsDisabled', false);

            break;
          case 'created':
              Globs.setActivityFlag(FLAG.CREATED);
              //Globs.set(KEY.OPTIONS_DISABLED, true);
              this.trigger('setOptionsDisabled', true);
              break;
          case 'running':
              Globs.setActivityFlag(FLAG.RUNNING);
              //Globs.set(KEY.OPTIONS_DISABLED, true);
              this.trigger('setOptionsDisabled', true);
              break;
          case 'paused':
              Globs.setActivityFlag(FLAG.PAUSED);
            //  Globs.set(KEY.OPTIONS_DISABLED, true);
              this.trigger('setOptionsDisabled', true);
              break;
          case 'cancelled':
            Globs.setActivityFlag(FLAG.IDLE);
            //Globs.set(KEY.OPTIONS_DISABLED, false);
            this.trigger('setOptionsDisabled', false);
            break;
          default:  break;
        }

        //console.log("zprocess %o status: %o", process, process['status']);
        this.markUI_nonBusy();
        //console.log('disabled:' +  Globs.get(KEY.OPTIONS_DISABLED));
        }
      },
      null,
      30
    );


    var Warning_msg_showed = false;
    this.bindPeriodicalObtain(
      this.OBTAINS().STATS,
      null,
      (data) => {
          console.log("followed");
          if(data['followed']==0 && data['unfollowed']==0 && Warning_msg_showed==false && localStorage.sub=='free')
          {

              confirmAlert({
                  title: 'SCHelper recommendation.', // Title dialog
                  message: (
                      <div>
                          We found out that you don't have a subscription, right?
                          <br/>
                          <br/>
                          We strongly recommend purchasing a SoundCloud subscription before using SCHelper.
                          <br/>
                          <br/>
                          Your account might not work properly with SCHelper without it.
                      </div>
                  ), // Message with line breaks
                  confirmLabel: 'Okay, I\'ll do it now', // Text button confirm
                  cancelLabel: 'Thanks, I\'ll do it later', // Text button cancel
                  onConfirm: () => {
                      window.open('https://checkout.soundcloud.com/artist', '_blank');
                  }, // Action after Confirm
                  onCancel: () => null, // Action after Cancel
              });
              Warning_msg_showed=true;
          }

          // console.log("followed:"+data['followed']);
          this.setState({followed:data['followed']});
          this.setState({unfollowed:data['unfollowed']});
          this.setState({time_spent:data['time_spent']});
      },
      null,
      20
    );
  }

  

  componentDidMount() {
    this.startObtain(this.OBTAINS().PROCESS);
    this.startObtain(this.OBTAINS().STATS);
  }

  componentWillUnmount(){
    this.cancelObtain(this.OBTAINS().PROCESS);
    this.cancelObtain(this.OBTAINS().STATS);
  }

  //---------------------------------
  //
  //           HANDLERS
  //
  //---------------------------------/

  handleCancelActivityClicked() {

    if(!(Globs.activityFlagIsPaused() || Globs.activityFlagIsCreated()))
    {
      return; //can cancel only paused
    }


    this.markUI_busy();

    RestClient.cancelLatestProcess(
      (data)=>{
        Globs.setActivityFlag(FLAG.IDLE);
        this.trigger('setOptionsDisabled', false);
        //this.redrawButtons();

        this.markUI_nonBusy();
        this.trigger('refreshLog');
      },
      ()=>{
        this.markUI_nonBusy();
        this.trigger('refreshLog');
      }
    ); //Resume


    this.setState({activityOn: !this.state.activityOn});
    //console.log('pause'+Globs.activityFlagIsPaused());
  }

  handleStartStopActivityClicked() {
    //console.log('handleStartStopActivityClicked');
    //add check if all data is entered correctly
    //Globs.set(SETTING.BUSY, true);
    //  this.markUI_busy();
    console.log('handleStartStopActivityClicked');

    if (CommonHelper.isNull(Entrance.purchaseEndTime())){

      confirmAlert({
       title: '',                        // Title dialog
       message: 'Please purchase a subscription for this account to start activity',               // Message dialog
       //childrenElement: () => <div>Custom UI</div>,       // Custom UI or Component
       confirmLabel: 'Purchase',                           // Text button confirm
       cancelLabel: '<<Back',                             // Text button cancel
       onConfirm: () => this.handlePurchase3M(),    // Action after Confirm
       //onCancel: () => alert('Action after Cancel'),      // Action after Cancel
       onCancel: () => null,
     });
     return ;
    }


    switch(Globs.activityFlag())
    {
      case FLAG.IDLE:
        //this.startActivity();
        var processName = this.getCurrentProcessName();
        var account_id = Entrance.accountId();

        //var start_timestamp = Math.floor(Date.now() / 1000); //seconds

        var theMoment = moment();
        theMoment.set({h: Globs.get(KEY.HH), m: Globs.get(KEY.MM)});

        var startMinutes = theMoment.hours()*60 + theMoment.minutes();
        var now = moment();

        var curMinutes = now.hours()*60 + now.minutes();

        var startMoment = theMoment.clone();
        // console.dir(startMoment);
        if (curMinutes > startMinutes) {//prevent immediate start
            startMoment.add(24, 'hours');
        }
        var start_timestamp = startMoment.unix();

          // startMoment=curMinutes;
          // startMoment.add(2, 'minutes');



        //console.log(startMoment.unix());

        // var m = moment();
        // m.set({h: Globs.getOption(OPTION.HH), m: Globs.getOption(OPTION.MM)});

        var follow = Globs.get(KEY.FOLLOW);
        var cyclic = Globs.get(KEY.CYCLIC);
        var follow_cnt = Globs.get(KEY.FOLLOW_CNT);
        var unfollow_cnt = Globs.get(KEY.UNFOLLOW_CNT);


        var todo = cyclic?(follow_cnt + unfollow_cnt):(follow?follow_cnt:unfollow_cnt);



        var hh = Globs.get(KEY.HH);
        var mm = Globs.get(KEY.MM);

        if(document.getElementById("schedule_on").checked==false) {
          let now1 = new Date();
          hh=now1.getHours();
          mm=now1.getMinutes()+1;
          // mm=now1.getMinutes();

          start_timestamp=moment().unix();
          start_timestamp=start_timestamp+60;
          // start_timestamp=start_timestamp;
        }
        var vars = {'url'         :Globs.get(KEY.URL),
                    //'todo'        :Globs.get(KEY.COUNT),
                    'todo'        :todo,
                    'follow_cnt'  :follow_cnt,
                    'unfollow_cnt':unfollow_cnt,
                    // 'schedule_on' :true,
                    'schedule_on' :document.getElementById("schedule_on").checked,
                    'pros_only'   :Globs.get(KEY.FOLLOW_PROS_ONLY),
                    'whitelist_only'   :Globs.get(KEY.WHITELIST_MANUAL_FOLLOWINGS),
                    'hh'          :hh,
                    'mm'          :mm,
                  };
    //{'zurl':'zzzurl'}
        if(!Globs.get(KEY.OPTIONS_ARE_CORRECT)) {
            confirmAlert({
             title: 'Startup error',                        // Title dialog
             message: 'Please correct your options.',               // Message dialog
             //childrenElement: () => <div>Custom UI</div>,       // Custom UI or Component
             confirmLabel: 'OK',                           // Text button confirm
             cancelLabel: null,                             // Text button cancel
             onConfirm: () => null,    // Action after Confirm
             //onCancel: () => alert('Action after Cancel'),      // Action after Cancel
             onCancel: () => null,
           });

          return;
        }


        this.markUI_busy();
        this.trigger('setOptionsDisabled', true);
        RestClient.scheduleProcess(processName, account_id, start_timestamp, vars,
          (data)=>{
            //ok?
            //Globs.setActivityFlag(FLAG.RUNNING);
            Globs.setActivityFlag(FLAG.CREATED);
            //this.redrawButtons();
            this.markUI_nonBusy();
            //this.trigger('setOptionsDisabled', true);
            this.trigger('refreshLog');

          },
          ()=>{
            this.markUI_nonBusy();
            this.trigger('setOptionsDisabled', false);
            this.trigger('refreshLog');

            confirmAlert({
              title: '',                        // Title dialog
              message: 'Not enough time credits to create or continue task.',               // Message dialog
              //childrenElement: () => <div>Custom UI</div>,       // Custom UI or Component
              confirmLabel: 'Purchase',                           // Text button confirm
              cancelLabel: '<<Back',                             // Text button cancel
              onConfirm: () => this.handlePurchase1M(),    // Action after Confirm
              //onCancel: () => alert('Action after Cancel'),      // Action after Cancel
              onCancel: () => null,
            });
            return ;
          }
        );
        break; //Start

      case FLAG.CREATED:
      case FLAG.RUNNING:
        this.markUI_busy();

        RestClient.pauseLatestProcess(
          (data)=>{
            Globs.setActivityFlag(FLAG.PAUSED);
            //this.redrawButtons();
            this.markUI_nonBusy();
            this.trigger('refreshLog');
          },
          ()=>{
            this.markUI_nonBusy();
            this.trigger('refreshLog');
          }
        );

      break; //Pause


      case FLAG.PAUSED:
        this.markUI_busy();

        RestClient.resumeLatestProcess(
          (data)=>{
            Globs.setActivityFlag(FLAG.RUNNING);

            //this.redrawButtons();

            this.markUI_nonBusy();
            this.trigger('refreshLog');
          },
          ()=>{
            this.markUI_nonBusy();
            this.trigger('refreshLog');
          }
        ); //Resume
        break;
      default:break;
    }



    //console.log (this.state.emailAddress);
    //return this.props.onCreateAccount(this.state);
  }


  //---------------------------------
  //
  //           RENDERINGS
  //
  //---------------------------------/
  markUI_busy() {

    Globs.set(KEY.BUSY, true);

    this.setState({redraw:!this.state.redraw});
  }

  markUI_nonBusy() {
    Globs.set(KEY.BUSY, false);

    this.setState({redraw:this.state.redraw});
  }



  renderBusySpinner() {
    return (
      <div className="sk-circle" style={{display:(Globs.get(KEY.BUSY)?'inline-block':'none')}}>
            <div className="sk-circle1 sk-child"></div>
            <div className="sk-circle2 sk-child"></div>
            <div className="sk-circle3 sk-child"></div>
            <div className="sk-circle4 sk-child"></div>
            <div className="sk-circle5 sk-child"></div>
            <div className="sk-circle6 sk-child"></div>
            <div className="sk-circle7 sk-child"></div>
            <div className="sk-circle8 sk-child"></div>
            <div className="sk-circle9 sk-child"></div>
            <div className="sk-circle10 sk-child"></div>
            <div className="sk-circle11 sk-child"></div>
            <div className="sk-circle12 sk-child"></div>
          </div>);
  }

  renderActivityAnimation() {
    return (
      <div className="blk-form-cell-centered"
      style={{width:'2em', height:'2em', boxSizing:'border-box'}}>

        <div style={{display:((Globs.activityFlagIsRunning()||Globs.activityFlagIsCreated())?'inline-block':'none')}}
        className="load-container load1" ><div className="loader"></div></div>


        <div className="redBackground" style={{display:(Globs.activityFlagIsIdle()?'inline-block':'none'),
        position:'relative',top:'0',left:'0',zIndex: '999'}}></div>

        <div className="yellowBackground" style={{display:(Globs.activityFlagIsPaused()?'inline-block':'none'),
        position:'relative',top:'0',left:'0',zIndex: '999'}}></div>
      </div>
    );
  }

  activityButtonTitle() {
    switch(Globs.activityFlag())
    {
      case FLAG.IDLE: return 'Start activity';
      case FLAG.RUNNING: return 'Pause activity';
      case FLAG.CREATED: return 'Pause activity';
      case FLAG.PAUSED: return 'Resume activity';
      //it is hidden
      //case FLAG.CREATED: return 'CREATED';
      default:break;
    }
    return 'undef';
  }

  activityButtonCSSId() {
    switch(Globs.activityFlag())
    {
      case FLAG.IDLE: return 'green'; //Start
      case FLAG.RUNNING: return 'yellow'; //Pause
      case FLAG.CREATED: return 'yellow'; //Pause
      case FLAG.PAUSED: return 'green'; //Resume
      default:break;
    }
    return 'green';
  }

  //<-- Renders

  getCurrentProcessName() {
      var processName = null;

      var follow = Globs.get(KEY.FOLLOW);
      //redundand
      //var unfollow = Globs.getOption(OPTION.UNFOLLOW);
      var cyclic = Globs.get(KEY.CYCLIC);
      var passive1st = Globs.get(KEY.UNFOLLOW_PASSIVE_1ST);

      if (follow)
      {
        if (cyclic)
        {
          processName = (passive1st)?'cyclic_follow_passive1st':'cyclic_follow';
        }else
        {
          processName = 'follow';
        }

      }else //!FOLLOW (UNFOLLOW)
      {
        if (cyclic)
        {
          processName = (passive1st)?'cyclic_unfollow_passive1st':'cyclic_unfollow';
        }else
        {
          processName = (passive1st)?'unfollow_passive1st':'unfollow';
        }
      }

      return processName;
  }

  redrawButtons() {
    this.setState({redraw:this.state.redraw+1});
  }
  pad0N(n) {
    return (n < 10) ? ('0' + n) : n;
  }

  render() {
    var strTimeSpent = CommonHelper.convertTimeToFineString(this.state.time_spent);

    return (
      <div className="panel-activity component-bottom-margin">
        <Container>
          <Row className='mb-4'>
            <Col xs="12" lg="3">
              <h1>
                Activity
                <span 
                  style={{display:((Globs.activityFlagIsRunning()||Globs.activityFlagIsCreated())?'inline-block':'none')}}
                  class="sc-spinner_wrapper">
                    <span class="sc-spinner">
                      <div class="sc-spinner_bar"></div>
                      <div class="sc-spinner_bar"></div>
                      <div class="sc-spinner_bar"></div>
                      <div class="sc-spinner_bar"></div>
                    </span>
                </span>
              </h1>
            </Col> 
            <Col xs="12" lg="4" xl="3">
              <Row className="justify-content-md-left">
                <Col xs="auto">
                  <button disabled={Globs.get(KEY.BUSY)} 
                      id={this.activityButtonCSSId()+((this.state.redraw)?'':'')} 
                      className={(Globs.activityFlagIsRunning() || Globs.activityFlagIsCreated())? 'sc-btn__play sc-btn__play--paused': 'sc-btn__play'}
                      onClick={this.handleStartStopActivityClicked}>
                    </button>
                </Col>
                <Col xs="auto">
                  <h2 className='activity-button-title'>{this.activityButtonTitle()}</h2>
                </Col>
              </Row>
            </Col>
            <Col xs="12" lg="4">
              <Row className="justify-content-md-left">
                <Col xs="auto">
                  <button id={'red'+((this.state.redraw)?'':'')}
                    disabled={Globs.get(KEY.BUSY)}
                    type='submit'
                    className='sc-btn__play sc-btn__play--stop'
                    style={(Globs.activityFlagIsPaused() || Globs.activityFlagIsCreated())?{display:'inline-block'}:{display:'none'}}
                    onClick={this.handleCancelActivityClicked}></button>
                </Col>
                <Col xs="auto">
                  <h2 className='activity-button-title' style={(Globs.activityFlagIsPaused() || Globs.activityFlagIsCreated())?{display:'inline-block'}:{display:'none'}}>
                    Cancel
                  </h2>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs="12" lg="4">
              <div className="sc-box">
                <div className='sc-box-top'>Time</div>
                <h2>{strTimeSpent}</h2>
              </div>
            </Col>
            <Col xs="12" lg="4">
              <div className="sc-box">
                <div className='sc-box-top'>Followings</div>
                <h2>{this.state.followed}</h2>
              </div>
            </Col>
            <Col xs="12" lg="4">
              <div className="sc-box">
                <div className='sc-box-top'>Unfollowings</div>
                <h2>{this.state.unfollowed}</h2>
              </div>
            </Col>
          </Row>
        </Container>
       
      </div>
    )
  }


}
